import _ from 'lodash';
import parameterMessages from 'domain/Options/parameterMessages';
import messages from './messages/kitchenIslandMessages';
import wallLocationMessages from './messages/wallLocationMessages';
import * as wallLocations from './images/wallLocations';
import overhangMessages from './messages/overhangMessages';
import * as sideImages from './images/overhangs/sides';
import RectangleRotated from './images/shapes/image_PLAN_BasicShape_Rectangle_Flipped.png';
import * as FlipImages from './images/shapes/flip-icon';
import { types as shapeTypes, filterWallLocations } from './shapes';
import KitchenIslandRectangular from './images/kitchenIslands/image_PLAN_KitchenIsland_Rectangular.png';


export const NO_KITCHEN_ISLAND_ID = 'no-kitchen-island';
export const KITCHEN_ISLAND_ID = 'kitchen-island';

const kitchenIslandWallLocations = {
  'no-walls': {
    image: wallLocations.Rectangle,
    flippedImage: wallLocations.Rectangle_Rotated,
    displayName: wallLocationMessages.noWalls,
    wallLocations: [],
  },
  'one-long-wall': {
    image: wallLocations.Rectangle_One_wall_side_long,
    flippedImage: wallLocations.Rectangle_Rotated_One_wall_side_long,
    displayName: wallLocationMessages.oneWall,
    wallLocations: ['a'],
  },
  'one-short-wall-left': {
    image: wallLocations.Rectangle_One_wall_side_short_left,
    flippedImage: wallLocations.Rectangle_Rotated_One_wall_side_short_left,
    displayName: wallLocationMessages.oneWall,
    wallLocations: ['b'],
    drawWalls: ['b1'],
  },
  'one-short-wall-right': {
    image: wallLocations.Rectangle_One_wall_side_short_right,
    flippedImage: wallLocations.Rectangle_Rotated_One_wall_side_short_right,
    displayName: wallLocationMessages.oneWall,
    wallLocations: ['b'],
    drawWalls: ['b2'],
  },
  'two-walls-left': {
    image: wallLocations.Rectangle_Two_wall_sides_left,
    flippedImage: wallLocations.Rectangle_Rotated_Two_wall_sides_left,
    displayName: wallLocationMessages.twoWalls,
    wallLocations: ['a', 'b'],
    drawWalls: ['b1'],
  },
  'two-walls-right': {
    image: wallLocations.Rectangle_Two_wall_sides_right,
    flippedImage: wallLocations.Rectangle_Rotated_Two_wall_sides_right,
    displayName: wallLocationMessages.twoWalls,
    wallLocations: ['a', 'b'],
    drawWalls: ['b2'],
  },
  'three-walls': {
    image: wallLocations.Rectangle_Three_wall_sides_default,
    flippedImage: wallLocations.Rectangle_Rotated_Three_wall_sides_default,
    displayName: wallLocationMessages.threeWalls,
    wallLocations: ['a', 'b', 'b'],
    drawWalls: ['b1', 'b2'],
  },
};

export function generateKitchenIslands(businessRules) {
  const { kitchenIslandShape } = businessRules;
  if (!kitchenIslandShape) {
    throw new Error('No default measurements for kitchen island');
  }
  return [
    {
      id: NO_KITCHEN_ISLAND_ID,
      displayName: messages.noKitchenIsland,
      kitchenIslandWallLocations: filterWallLocations(kitchenIslandWallLocations, kitchenIslandShape.wallLocations),
    },
    {
      id: KITCHEN_ISLAND_ID,
      displayName: parameterMessages.kitchenIsland,
      displayImage: KitchenIslandRectangular,
      flippedImage: RectangleRotated,
      flippable: {
        left: FlipImages.FlipR2,
        right: FlipImages.FlipR,
      },
      dimensions: {
        a: {
          defaultValue: kitchenIslandShape.defaultMeasurements.a,
          type: shapeTypes.LENGTH,
        },
        b: {
          defaultValue: kitchenIslandShape.defaultMeasurements.b,
          type: shapeTypes.DEPTH,
        },
      },
      wallDrawingOrder: ['b1', 'a', 'b2'],
      overhangSides: _.map({
        'one-side-left': {
          displayImage: sideImages.KitchenIsland_OH_one_Left,
          displayName: overhangMessages.oneSide,
          dimensions: {
            z: {
              length: 'a',
              depth: 'b',
              side: 'b1',
            },
          },
        },
        'one-side-right': {
          displayImage: sideImages.KitchenIsland_OH_one_Right,
          displayName: overhangMessages.oneSide,
          dimensions: {
            z: {
              length: 'a',
              depth: 'b',
              side: 'b2',
            },
          },
        },
        'two-sides-left-right': {
          displayImage: sideImages.KitchenIsland_OH_two_Left_Right,
          displayName: overhangMessages.twoSides,
          dimensions: {
            y: {
              length: 'a',
              depth: 'b',
              side: 'b1',
            },
            z: {
              length: 'a',
              depth: 'b',
              side: 'b2',
            },
          },
        },
      }, (side, key) => {
        return {
          id: key,
          ...side,
        };
      }),
      kitchenIslandWallLocations: filterWallLocations(kitchenIslandWallLocations, kitchenIslandShape.wallLocations),
    },
  ];
}
